;(() => {
  class KlaviyoForm {
    constructor(form, options = {}) {
      this.form = form
      this.successMessage = form.querySelector('[data-alert-success]')
      this.errMessage = form.querySelector('[data-alert-err]')
      this.submitButton = form.querySelector('button[type="submit"]')
      this.options = {
        formType: form.dataset.formType,
        subscriptionSource: form.dataset.subscriptionSource,
        ...options,
      }

      this.initializeForm()
    }

    initializeForm() {
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault()
        const { list_id, public_api_key } = window.klaviyo_config
        const formData = new FormData(this.form)
        const klaviyoProperties = {}
        const searchParams = new URLSearchParams(window.location.search)

        for (const [key, value] of formData.entries()) {
          if (key === 'email') continue
          klaviyoProperties[key] = value
        }

        for (const [key, value] of searchParams.entries()) {
          if (key.toLocaleLowerCase().includes('utm')) {
            klaviyoProperties[key] = value
          }
        }

        const klaviyoData = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: formData.get('email'),
                    properties: {
                      ...klaviyoProperties,
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: list_id,
                },
              },
            },
          },
        }

        await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${public_api_key}`, {
          method: 'POST',
          headers: {
            revision: '2024-07-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify(klaviyoData),
        })
          .then((res) => {
            if (res.status === 202) {
              window.dataLayer = window.dataLayer || []
              dataLayer.push({
                event: 'generate_lead',
                subscription_source: this.options.subscriptionSource,
                user_data: {
                  email: formData.get('email'),
                },
              })
              this.submitButton.setAttribute('aria-busy', 'false')
              this.successMessage.hidden = false
              return
            }
            return res.json()
          })
          .catch((err) => {
            console.error('error:' + err)
            this.submitButton.setAttribute('aria-busy', 'false')
            this.errMessage.hidden = false
            return
          })
      })
    }
  }
  const klaviyoForms = document.querySelectorAll('[data-subscription-klaviyo-form]')
  klaviyoForms.forEach((form) => new KlaviyoForm(form))
})()
